import { createContext, useContext, useState } from "react";
import { LicenseDetails } from "../views/Licenses/Licenses/LicenseDetails";

const LicenseDetailsContext = createContext({
   license: null,
   showModal: false,
   currentTab: null,
   currentSubTab: null,
   isLoading: false,
   closeModal: () => { },
   openModal: (license, currentTab) => { },
   setLicense: (license) => { },
   setShowModal: (showModal) => { },
   setCurrentTab: (currentTab) => { },
   setCurrentSubTab: (currentSubTab) => { },
});

export function LicenseDetailsProvider({ children }) {
   const [license, setLicense] = useState();
   const [showModal, setShowModal] = useState(false);
   const [currentTab, setCurrentTab] = useState("overview");
   const [currentSubTab, setCurrentSubTab] = useState(null);
   const [isLoading, setIsLoading] = useState(false);

   function openModal(
      license, currentTab = "overview", currentSubTab = null
   ) {
      setLicense(license);
      setCurrentTab(currentTab);
      setCurrentSubTab(currentSubTab);
      setShowModal(true);
   }

   function closeModal() {
      setShowModal(false);
      if (typeof window !== "undefined") {
         window.dispatchEvent(new Event("license-details-closed"));
      }
   }

   return (
      <LicenseDetailsContext.Provider value={{
         license, setLicense,
         showModal, setShowModal,
         currentTab, setCurrentTab,
         currentSubTab, setCurrentSubTab,
         isLoading, setIsLoading,
         openModal,
         closeModal,
      }}>
         {children}
         <LicenseDetails />
      </LicenseDetailsContext.Provider>
   );
}

export function useLicenseDetails() {
   const context = useContext(LicenseDetailsContext);
   return context;
}